import type { User } from "firebase/auth";
import { callRunWeeklyLeaderboardNow } from "@/cloud/game-callables";
import { isoWeekKeyUtc } from "@/rank/leaderboard-types";

export function renderGmControlSectionHtml(): string {
  const weekKey = isoWeekKeyUtc();
  return `
    <section class="gm-section" id="gm-control-section">
      <p class="hint">เครื่องมือ owner · กระทบผู้เล่นทั้งระบบ — ใช้เมื่อจำเป็น</p>

      <article class="gm-card gm-control-card">
        <h3 class="gm-card-title">อันดับโลก (Rank)</h3>
        <p class="gm-card-desc">
          บังคับคำนวณ top 10 ทั้ง 3 บอร์ด (ต่อสู้ · หอคอย · รำรวย) และแจกป้ายแรงค์สัปดาห์นี้
        </p>
        <p class="hint">รอบปกติ: จันทร์ 00:00 UTC · รอบปัจจุบัน (UTC): <strong>${weekKey}</strong></p>
        <div class="home-actions">
          <button type="button" class="btn btn-primary" id="gm-control-rank-snapshot">
            บังคับคำนวณ Rank ตอนนี้
          </button>
        </div>
        <p class="hint gm-control-status" id="gm-control-rank-status" role="status"></p>
      </article>
    </section>
  `;
}

export function bindGmControlSection(root: HTMLElement, _user: User): () => void {
  const statusEl = root.querySelector<HTMLElement>("#gm-control-rank-status");
  const btn = root.querySelector<HTMLButtonElement>("#gm-control-rank-snapshot");

  const setStatus = (message: string, isError = false) => {
    if (!statusEl) return;
    statusEl.textContent = message;
    statusEl.classList.toggle("gm-control-status--error", isError);
  };

  const onSnapshot = () => {
    if (!btn) return;
    btn.disabled = true;
    setStatus("กำลังคำนวณ…");
    void (async () => {
      try {
        const res = await callRunWeeklyLeaderboardNow();
        setStatus(`คำนวณสำเร็จ · รอบ ${res.weekKey} · ป้ายแรงค์อัปเดตแล้ว`);
      } catch (err) {
        setStatus(err instanceof Error ? err.message : "คำนวณไม่สำเร็จ", true);
      } finally {
        btn.disabled = false;
      }
    })();
  };

  btn?.addEventListener("click", onSnapshot);

  return () => {
    btn?.removeEventListener("click", onSnapshot);
  };
}
